// import { useState, useEffect } from "react";
// import { Card } from "@/components/ui/card";
// import { Badge } from "@/components/ui/badge";
// import { Button } from "@/components/ui/button";
// import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
// import ConsultationModal from "@/components/ConsultationModal";
// import {
//   Heart, Bone, Shield, Brain, HeartPulse, Smile, Sparkles, Scissors, Baby,
//   Activity, Eye, Ear, Stethoscope, Droplets, Leaf, User, ArrowRight
// } from "lucide-react";
// import axios from "axios";

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// const ICONS = { Heart, Bone, Shield, Brain, HeartPulse, Smile, Sparkles, Scissors, Baby, Activity, Eye, Ear, Stethoscope, Droplets, Leaf, User };

// const categories = {
//   all: "All Treatments",
//   medical: "Medical & Surgical",
//   dental: "Dental & Skin",
//   wellness: "Wellness & Holistic",
// };

// const categoryMap = {
//   cardiology: "medical", orthopedics: "medical", oncology: "medical",
//   "neurology": "medical", "organ-transplant": "medical", "ivf": "medical",
//   bariatric: "medical", ophthalmology: "medical", ent: "medical",
//   gastro: "medical", nephrology: "medical",
//   dental: "dental", dermatology: "dental", "cosmetic-surgery": "dental", "hair-transplant": "dental",
//   ayurveda: "wellness",
// };

// export default function TreatmentsPage() {
//   const [treatments, setTreatments] = useState([]);
//   const [activeTab, setActiveTab] = useState("all");

//   useEffect(() => {
//     axios.get(`${API}/treatments`).then(r => setTreatments(r.data)).catch(console.error);
//   }, []);

//   const filtered = activeTab === "all" ? treatments : treatments.filter(t => categoryMap[t.id] === activeTab);

//   return (
//     <div data-testid="treatments-page">
//       <section className="bg-gradient-to-b from-orange-50 to-white py-16 md:py-24">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//           <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">16+ Specialties</Badge>
//           <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-slate-900 mb-4" data-testid="treatments-title">Our Treatment Specialties</h1>
//           <p className="text-base md:text-lg text-slate-500 max-w-2xl mx-auto">We cover all medical needs, from dental implants to heart transplants, with India's top hospitals and surgeons.</p>
//         </div>
//       </section>

//       <section className="py-12 md:py-20">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
//             <TabsList className="bg-slate-100 rounded-full p-1 mb-10 flex flex-wrap justify-center gap-1" data-testid="treatments-tabs">
//               {Object.entries(categories).map(([key, label]) => (
//                 <TabsTrigger key={key} value={key} className="rounded-full px-5 py-2 text-sm data-[state=active]:bg-orange-600 data-[state=active]:text-black" data-testid={`tab-${key}`}>
//                   {label}
//                 </TabsTrigger>
//               ))}
//             </TabsList>

//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
//               {filtered.map((t) => {
//                 const IconComp = ICONS[t.icon] || Heart;
//                 return (
//                   // <Card key={t.id} className="bg-white border border-slate-100 rounded-2xl p-6 hover:border-emerald-300 hover:shadow-lg transition-all card-hover" data-testid={`treatment-card-${t.id}`}>
//                   //   <div className="w-12 h-12 rounded-xl bg-orange-600/10 flex items-center justify-center mb-4">
//                   //     {/* <IconComp className="h-6 w-6 text-orange-600" /> */}
//                   //     <div className="h-40 relative">
//                   //       <img src={t.image_url} alt={t.name} className="w-full h-full object-cover" />
//                   //       {/* <div className="absolute top-3 right-3">
//                   //         <Badge className="bg-white/90 text-orange-600 border-0 shadow-md font-semibold text-xs">{h.accreditation}</Badge>
//                   //       </div> */}
//                   //     </div>
//                   //   </div>
//                   //   <h3 className="font-heading text-lg font-semibold text-slate-900 mb-2">{t.name}</h3>
//                   //   <p className="text-slate-500 text-sm leading-relaxed mb-4">{t.description}</p>
//                   //   <div className="flex items-center justify-between">
//                   //     <span className="text-orange-600 font-bold text-sm">{t.price_range || `From ${t.price_from}`}</span>
//                   //     <ConsultationModal
//                   //       trigger={
//                   //         <Button size="sm" className="bg-orange-600 hover:bg-orange-700 text-white rounded-full text-xs px-4" data-testid={`get-quote-${t.id}`}>
//                   //           Get Quote
//                   //         </Button>
//                   //       }
//                   //     />
//                   //   </div>
//                   // </Card>
//                   <Card
//                     key={t.id}
//                     className="group bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
//                   >
//                     {/* IMAGE SECTION */}
//                     <div className="relative h-48 w-full overflow-hidden">
//                       <img
//                         src={t.image_url}
//                         alt={t.name}
//                         className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
//                       />

//                       {/* Gradient Overlay */}
//                       <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>

//                       {/* Price Badge */}
//                       <div className="absolute top-3 right-3 bg-white text-orange-600 text-xs font-bold px-3 py-1 rounded-full shadow">
//                         {t.price_range || `From ${t.price_from}`}
//                       </div>
//                     </div>

//                     {/* CONTENT */}
//                     <div className="p-5">
//                       <h3 className="font-heading text-lg font-semibold text-slate-900 mb-2 group-hover:text-orange-600 transition-colors">
//                         {t.name}
//                       </h3>

//                       <p className="text-slate-500 text-sm leading-relaxed mb-4 line-clamp-2">
//                         {t.description}
//                       </p>

//                       {/* ACTION */}
//                       <div className="flex items-center justify-between">
//                         <span className="text-xs text-slate-400">Quick Consultation</span>

//                         <ConsultationModal
//                           trigger={
//                             <Button
//                               size="sm"
//                               className="bg-orange-600 hover:bg-orange-700 text-white rounded-full text-xs px-4 shadow-md hover:shadow-lg transition-all"
//                             >
//                               Get Quote
//                             </Button>
//                           }
//                         />
//                       </div>
//                     </div>
//                   </Card>
//                 );
//               })}
//             </div>
//           </Tabs>
//         </div>
//       </section>

//       <section className="bg-slate-900 py-16 text-center">
//         <div className="max-w-3xl mx-auto px-4">
//           <h2 className="font-heading text-3xl font-semibold text-white mb-4">Can't Find Your Treatment?</h2>
//           <p className="text-slate-300 mb-8">We can arrange treatment in any hospital across India. Contact us with your medical details and we'll find the best option for you.</p>
//           <ConsultationModal
//             trigger={
//               <Button className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold text-base" data-testid="treatments-cta-btn">
//                 Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
//               </Button>
//             }
//           />
//         </div>
//       </section>
//     </div>
//   );
// }


// import { useState, useEffect, useMemo } from "react";
// import { Card } from "@/components/ui/card";
// import { Badge } from "@/components/ui/badge";
// import { Button } from "@/components/ui/button";
// import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
// import ConsultationModal from "@/components/ConsultationModal";
// import {
//   Heart, Bone, Shield, Brain, HeartPulse, Smile, Sparkles, Scissors, Baby,
//   Activity, Eye, Ear, Stethoscope, Droplets, Leaf, User, ArrowRight,
//   Search, X
// } from "lucide-react";
// import axios from "axios";

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// const ICONS = { Heart, Bone, Shield, Brain, HeartPulse, Smile, Sparkles, Scissors, Baby, Activity, Eye, Ear, Stethoscope, Droplets, Leaf, User };

// const categories = {
//   all: "All Treatments",
//   medical: "Medical & Surgical",
//   dental: "Dental & Skin",
//   wellness: "Wellness & Holistic",
// };

// const categoryMap = {
//   cardiology: "medical", orthopedics: "medical", oncology: "medical",
//   "neurology": "medical", "organ-transplant": "medical", "ivf": "medical",
//   bariatric: "medical", ophthalmology: "medical", ent: "medical",
//   gastro: "medical", nephrology: "medical",
//   dental: "dental", dermatology: "dental", "cosmetic-surgery": "dental", "hair-transplant": "dental",
//   ayurveda: "wellness",
// };

// export default function TreatmentsPage() {
//   const [treatments, setTreatments] = useState([]);
//   const [activeTab, setActiveTab] = useState("all");
//   const [searchQuery, setSearchQuery] = useState("");

//   useEffect(() => {
//     axios.get(`${API}/treatments`).then(r => setTreatments(r.data)).catch(console.error);
//   }, []);

//   // ── Filter: tab + search combined ──────────────────────────────────────────
//   const filtered = useMemo(() => {
//     let result = activeTab === "all"
//       ? treatments
//       : treatments.filter(t => categoryMap[t.id] === activeTab);

//     if (searchQuery.trim()) {
//       const q = searchQuery.toLowerCase().trim();
//       result = result.filter(t =>
//         t.name?.toLowerCase().includes(q) ||
//         t.description?.toLowerCase().includes(q) ||
//         t.id?.toLowerCase().includes(q)
//       );
//     }

//     return result;
//   }, [treatments, activeTab, searchQuery]);

//   const handleSearchClear = () => setSearchQuery("");

//   const handleTabChange = (val) => {
//     setActiveTab(val);
//     setSearchQuery("");
//   };

//   return (
//     <div data-testid="treatments-page">

//       {/* ── HERO ────────────────────────────────────────────────────────────── */}
//       <section className="bg-gradient-to-b from-orange-50 to-white pt-16 md:pt-24 pb-0">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//           <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">
//             16+ Specialties
//           </Badge>
//           <h1
//             className="font-heading text-4xl sm:text-5xl font-semibold text-slate-900 mb-4"
//             data-testid="treatments-title"
//           >
//             Our Treatment Specialties
//           </h1>
//           <p className="text-base md:text-lg text-slate-500 max-w-2xl mx-auto mb-10">
//             We cover all medical needs, from dental implants to heart transplants,
//             with India's top hospitals and surgeons.
//           </p>

//           {/* ── Search Bar ── */}
//           <div className="max-w-xl mx-auto relative">
//             <div className="flex items-center bg-white border-2 border-orange-100 focus-within:border-orange-500 rounded-full shadow-md px-5 py-3 transition-all duration-200">
//               <Search className="h-5 w-5 text-orange-400 flex-shrink-0 mr-3" />
//               <input
//                 type="text"
//                 placeholder="Search treatments e.g. Knee Replacement, Dental..."
//                 value={searchQuery}
//                 onChange={e => setSearchQuery(e.target.value)}
//                 className="flex-1 bg-transparent outline-none text-slate-700 text-sm placeholder:text-slate-400"
//                 data-testid="treatment-search-input"
//               />
//               {searchQuery && (
//                 <button
//                   onClick={handleSearchClear}
//                   className="ml-2 text-slate-400 hover:text-orange-500 transition-colors"
//                   data-testid="search-clear-btn"
//                 >
//                   <X className="h-4 w-4" />
//                 </button>
//               )}
//             </div>

//             {/* Live Result Count */}
//             {searchQuery.trim() && (
//               <p className="text-xs text-slate-400 mt-2 text-center">
//                 {filtered.length > 0
//                   ? (
//                     <span>
//                       Showing{" "}
//                       <span className="text-orange-500 font-semibold">{filtered.length}</span>
//                       {" "}result{filtered.length > 1 ? "s" : ""} for "
//                       <span className="text-slate-600 font-medium">{searchQuery}</span>"
//                     </span>
//                   ) : (
//                     <span>
//                       No results found for "
//                       <span className="text-slate-600 font-medium">{searchQuery}</span>"
//                     </span>
//                   )
//                 }
//               </p>
//             )}
//           </div>
//         </div>
//       </section>

//       {/* ── TREATMENTS GRID ─────────────────────────────────────────────────── */}
//       <section className="pb-12 md:pb-20 pt-6">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <Tabs value={activeTab} onValueChange={handleTabChange} className="w-full">

//             {/* Tabs */}
//             <TabsList
//               className="bg-slate-100 rounded-full p-1 mb-10 flex flex-wrap justify-center gap-1"
//               data-testid="treatments-tabs"
//             >
//               {Object.entries(categories).map(([key, label]) => (
//                 <TabsTrigger
//                   key={key}
//                   value={key}
//                   className="rounded-full px-5 py-2 text-sm data-[state=active]:bg-orange-600 data-[state=active]:text-white"
//                   data-testid={`tab-${key}`}
//                 >
//                   {label}
//                 </TabsTrigger>
//               ))}
//             </TabsList>

//             {/* Grid */}
//             {filtered.length > 0 ? (
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
//                 {filtered.map((t) => {
//                   const IconComp = ICONS[t.icon] || Heart;
//                   return (
//                     <Card
//                       key={t.id}
//                       className="group bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
//                       data-testid={`treatment-card-${t.id}`}
//                     >
//                       {/* Image */}
//                       <div className="relative h-48 w-full overflow-hidden">
//                         <img
//                           src={t.image_url}
//                           alt={t.name}
//                           className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
//                         />
//                         <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
//                         <div className="absolute top-3 right-3 bg-white text-orange-600 text-xs font-bold px-3 py-1 rounded-full shadow">
//                           {t.price_range || `From ${t.price_from}`}
//                         </div>
//                       </div>

//                       {/* Content */}
//                       <div className="p-5">
//                         <h3 className="font-heading text-lg font-semibold text-slate-900 mb-2 group-hover:text-orange-600 transition-colors">
//                           {searchQuery.trim()
//                             ? highlightMatch(t.name, searchQuery)
//                             : t.name
//                           }
//                         </h3>
//                         <p className="text-slate-500 text-sm leading-relaxed mb-4 line-clamp-2">
//                           {t.description}
//                         </p>
//                         <div className="flex items-center justify-between">
//                           <span className="text-xs text-slate-400">Quick Consultation</span>
//                           <ConsultationModal
//                             trigger={
//                               <Button
//                                 size="sm"
//                                 className="bg-orange-600 hover:bg-orange-700 text-white rounded-full text-xs px-4 shadow-md hover:shadow-lg transition-all"
//                                 data-testid={`get-quote-${t.id}`}
//                               >
//                                 Get Quote
//                               </Button>
//                             }
//                           />
//                         </div>
//                       </div>
//                     </Card>
//                   );
//                 })}
//               </div>
//             ) : (
//               /* ── Empty State ── */
//               <div className="flex flex-col items-center justify-center py-24 text-center">
//                 <div className="w-20 h-20 rounded-full bg-orange-50 flex items-center justify-center mb-6">
//                   <Search className="h-9 w-9 text-orange-300" />
//                 </div>
//                 <h3 className="text-xl font-semibold text-slate-700 mb-2">No treatments found</h3>
//                 <p className="text-slate-400 text-sm max-w-sm mb-6">
//                   We couldn't find any treatments matching "
//                   <span className="text-orange-500 font-medium">{searchQuery}</span>
//                   ". Try a different keyword or browse all treatments.
//                 </p>
//                 <Button
//                   onClick={handleSearchClear}
//                   className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-6"
//                 >
//                   Clear Search
//                 </Button>
//               </div>
//             )}

//           </Tabs>
//         </div>
//       </section>

//       {/* ── BOTTOM CTA ──────────────────────────────────────────────────────── */}
//       <section className="bg-slate-900 py-16 text-center">
//         <div className="max-w-3xl mx-auto px-4">
//           <h2 className="font-heading text-3xl font-semibold text-white mb-4">
//             Can't Find Your Treatment?
//           </h2>
//           <p className="text-slate-300 mb-8">
//             We can arrange treatment in any hospital across India. Contact us with
//             your medical details and we'll find the best option for you.
//           </p>
//           <ConsultationModal
//             trigger={
//               <Button
//                 className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold text-base"
//                 data-testid="treatments-cta-btn"
//               >
//                 Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
//               </Button>
//             }
//           />
//         </div>
//       </section>

//     </div>
//   );
// }


// // ── Highlight Helper ──────────────────────────────────────────────────────────
// function highlightMatch(text, query) {
//   if (!query || !text) return text;
//   const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
//   const parts = text.split(regex);
//   return parts.map((part, i) =>
//     regex.test(part)
//       ? <mark key={i} style={{ backgroundColor: '#FFF0EB', color: '#F04E30', borderRadius: '3px', padding: '0 2px', fontWeight: 700 }}>{part}</mark>
//       : part
//   );
// }



// TreatmentsPage.jsx
// import { useState, useEffect, useMemo } from "react";
// import { Card } from "@/components/ui/card";
// import { Badge } from "@/components/ui/badge";
// import { Button } from "@/components/ui/button";
// import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
// import ConsultationModal from "@/components/ConsultationModal";
// import {
//   Heart, Bone, Shield, Brain, HeartPulse, Smile, Sparkles, Scissors, Baby,
//   Activity, Eye, Ear, Stethoscope, Droplets, Leaf, User, ArrowRight,
//   Search, X
// } from "lucide-react";
// import axios from "axios";

// const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
// const ICONS = {
//   Heart, Bone, Shield, Brain, HeartPulse, Smile, Sparkles,
//   Scissors, Baby, Activity, Eye, Ear, Stethoscope, Droplets, Leaf, User
// };

// const categories = {
//   all: "All Treatments",
//   medical: "Medical & Surgical",
//   dental: "Dental & Skin",
//   wellness: "Wellness & Holistic",
// };

// const categoryMap = {
//   cardiology: "medical", orthopedics: "medical", oncology: "medical",
//   neurology: "medical", "organ-transplant": "medical", ivf: "medical",
//   bariatric: "medical", ophthalmology: "medical", ent: "medical",
//   gastro: "medical", nephrology: "medical",
//   dental: "dental", dermatology: "dental", "cosmetic-surgery": "dental",
//   "hair-transplant": "dental",
//   ayurveda: "wellness",
// };

// export default function TreatmentsPage() {
//   const [treatments, setTreatments] = useState([]);
//   const [activeTab, setActiveTab] = useState("all");
//   const [searchQuery, setSearchQuery] = useState("");

//   useEffect(() => {
//     axios.get(`${API}/treatments`).then(r => setTreatments(r.data)).catch(console.error);
//   }, []);

//   // ── Filter: tab + search combined ──
//   const filtered = useMemo(() => {
//     let result = activeTab === "all"
//       ? treatments
//       : treatments.filter(t => categoryMap[t.id] === activeTab);

//     if (searchQuery.trim()) {
//       const q = searchQuery.toLowerCase().trim();
//       result = result.filter(t =>
//         t.name?.toLowerCase().includes(q) ||
//         t.description?.toLowerCase().includes(q) ||
//         t.id?.toLowerCase().includes(q)
//       );
//     }

//     return result;
//   }, [treatments, activeTab, searchQuery]);

//   const handleSearchClear = () => setSearchQuery("");

//   const handleTabChange = (val) => {
//     setActiveTab(val);
//     setSearchQuery("");
//   };

//   return (
//     <div data-testid="treatments-page">

//       {/* ── Hero + Search Section ── */}
//       <section className="bg-gradient-to-b from-orange-50 to-white py-10 md:py-14">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

//           {/* Heading */}
//           <div className="text-center mb-10">
//             <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">
//               16+ Specialties
//             </Badge>
//             <h1
//               className="font-heading text-4xl sm:text-5xl font-semibold text-slate-900 mb-4"
//               data-testid="treatments-title"
//             >
//               Our Treatment <span className="text-orange-600">Specialties</span>
//             </h1>
//             <p className="text-base md:text-lg text-slate-500 max-w-2xl mx-auto">
//               We cover all medical needs, from dental implants to heart transplants,
//               with India's top hospitals and surgeons.
//             </p>
//           </div>

//           {/* Search Bar */}
//           <div className="max-w-2xl mx-auto">
//             <div className="flex items-center bg-white border-2 border-orange-100 focus-within:border-orange-500 rounded-full shadow-md px-5 py-3 transition-all duration-200">
//               <Search className="h-5 w-5 text-orange-400 flex-shrink-0 mr-3" />
//               <input
//                 type="text"
//                 placeholder="Search treatments e.g. Knee Replacement, Dental..."
//                 value={searchQuery}
//                 onChange={e => setSearchQuery(e.target.value)}
//                 className="flex-1 bg-transparent outline-none text-slate-700 text-sm placeholder:text-slate-400"
//                 data-testid="treatment-search-input"
//               />
//               {searchQuery && (
//                 <button
//                   onClick={handleSearchClear}
//                   className="ml-2 text-slate-400 hover:text-orange-500 transition-colors"
//                   data-testid="search-clear-btn"
//                 >
//                   <X className="h-4 w-4" />
//                 </button>
//               )}
//             </div>

//             {/* Live Result Count */}
//             {searchQuery.trim() && (
//               <p className="text-xs text-slate-400 mt-2 text-center">
//                 {filtered.length > 0 ? (
//                   <span>
//                     Showing{" "}
//                     <span className="text-orange-500 font-semibold">{filtered.length}</span>
//                     {" "}result{filtered.length > 1 ? "s" : ""} for "
//                     <span className="text-slate-600 font-medium">{searchQuery}</span>"
//                   </span>
//                 ) : (
//                   <span>
//                     No results found for "
//                     <span className="text-slate-600 font-medium">{searchQuery}</span>"
//                   </span>
//                 )}
//               </p>
//             )}
//           </div>

//         </div>
//       </section>

//       {/* ── Treatments Grid ── */}
//       <section className="py-10 md:py-14 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <Tabs value={activeTab} onValueChange={handleTabChange} className="w-full">

//             {/* Tab Pills */}
//             <TabsList
//               className="bg-slate-100 rounded-full p-1 mb-10 flex flex-wrap justify-center gap-1"
//               data-testid="treatments-tabs"
//             >
//               {Object.entries(categories).map(([key, label]) => (
//                 <TabsTrigger
//                   key={key}
//                   value={key}
//                   className="rounded-full px-5 py-2 text-sm data-[state=active]:bg-orange-600 data-[state=active]:text-white"
//                   data-testid={`tab-${key}`}
//                 >
//                   {label}
//                 </TabsTrigger>
//               ))}
//             </TabsList>

//             {/* Cards or Empty State */}
//             {filtered.length > 0 ? (
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
//                 {filtered.map((t) => {
//                   const IconComp = ICONS[t.icon] || Heart;
//                   return (
//                     <Card
//                       key={t.id}
//                       className="group bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
//                       data-testid={`treatment-card-${t.id}`}
//                     >
//                       {/* Image */}
//                       <div className="relative h-48 w-full overflow-hidden">
//                         <img
//                           src={t.image_url}
//                           alt={t.name}
//                           className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
//                         />
//                         <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
//                         <div className="absolute top-3 right-3 bg-white text-orange-600 text-xs font-bold px-3 py-1 rounded-full shadow">
//                           {t.price_range || `From ${t.price_from}`}
//                         </div>
//                       </div>

//                       {/* Content */}
//                       <div className="p-5">
//                         <h3 className="font-heading text-lg font-semibold text-slate-900 mb-2 group-hover:text-orange-600 transition-colors">
//                           {searchQuery.trim()
//                             ? highlightMatch(t.name, searchQuery)
//                             : t.name
//                           }
//                         </h3>
//                         <p className="text-slate-500 text-sm leading-relaxed mb-4 line-clamp-2">
//                           {t.description}
//                         </p>
//                         <div className="flex items-center justify-between">
//                           <span className="text-xs text-slate-400">Quick Consultation</span>
//                           <ConsultationModal
//                             trigger={
//                               <Button
//                                 size="sm"
//                                 className="bg-orange-600 hover:bg-orange-700 text-white rounded-full text-xs px-4 shadow-md hover:shadow-lg transition-all"
//                                 data-testid={`get-quote-${t.id}`}
//                               >
//                                 Get Quote
//                               </Button>
//                             }
//                           />
//                         </div>
//                       </div>
//                     </Card>
//                   );
//                 })}
//               </div>
//             ) : (
//               /* ── Empty State ── */
//               <div className="flex flex-col items-center justify-center py-24 text-center">
//                 <div className="w-20 h-20 rounded-full bg-orange-50 flex items-center justify-center mb-6">
//                   <Search className="h-9 w-9 text-orange-300" />
//                 </div>
//                 <h3 className="text-xl font-semibold text-slate-700 mb-2">No treatments found</h3>
//                 <p className="text-slate-400 text-sm max-w-sm mb-6">
//                   We couldn't find any treatments matching "
//                   <span className="text-orange-500 font-medium">{searchQuery}</span>
//                   ". Try a different keyword or browse all treatments.
//                 </p>
//                 <Button
//                   onClick={handleSearchClear}
//                   className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-6"
//                 >
//                   Clear Search
//                 </Button>
//               </div>
//             )}

//           </Tabs>
//         </div>
//       </section>

//       {/* ── Bottom CTA ── */}
//       <section className="bg-slate-900 py-16 text-center">
//         <div className="max-w-3xl mx-auto px-4">
//           <h2 className="font-heading text-3xl font-semibold text-white mb-4">
//             Can't Find Your Treatment?
//           </h2>
//           <p className="text-slate-300 mb-8">
//             We can arrange treatment in any hospital across India. Contact us with
//             your medical details and we'll find the best option for you.
//           </p>
//           <ConsultationModal
//             trigger={
//               <Button
//                 className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold text-base"
//                 data-testid="treatments-cta-btn"
//               >
//                 Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
//               </Button>
//             }
//           />
//         </div>
//       </section>

//     </div>
//   );
// }

// // ── Highlight Helper ──
// function highlightMatch(text, query) {
//   if (!query || !text) return text;
//   const regex = new RegExp(
//     `(${query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`,
//     "gi"
//   );
//   const parts = text.split(regex);
//   return parts.map((part, i) =>
//     regex.test(part) ? (
//       <mark
//         key={i}
//         style={{
//           backgroundColor: "#FFF0EB",
//           color: "#F04E30",
//           borderRadius: "3px",
//           padding: "0 2px",
//           fontWeight: 700,
//         }}
//       >
//         {part}
//       </mark>
//     ) : (
//       part
//     )
//   );
// }


// TreatmentsPage.jsx
import { useState, useEffect, useMemo } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ConsultationModal from "@/components/ConsultationModal";
import { useNavigate } from "react-router-dom";
import {
  Heart, Bone, Shield, Brain, HeartPulse, Smile, Sparkles, Scissors, Baby,
  Activity, Eye, Ear, Stethoscope, Droplets, Leaf, User, ArrowRight,
  Search, X
} from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ICONS = {
  Heart, Bone, Shield, Brain, HeartPulse, Smile, Sparkles,
  Scissors, Baby, Activity, Eye, Ear, Stethoscope, Droplets, Leaf, User
};

const categories = {
  all: "All Treatments",
  medical: "Medical & Surgical",
  dental: "Dental & Skin",
  wellness: "Wellness & Holistic",
};

const categoryMap = {
  cardiology: "medical", orthopedics: "medical", oncology: "medical",
  neurology: "medical", "organ-transplant": "medical", ivf: "medical",
  bariatric: "medical", ophthalmology: "medical", ent: "medical",
  gastro: "medical", nephrology: "medical",
  dental: "dental", dermatology: "dental", "cosmetic-surgery": "dental",
  "hair-transplant": "dental",
  ayurveda: "wellness",
};

// ── Treatment ID → Route Path Map ──
const treatmentRouteMap = {
  // Medical & Surgical
  cardiology:         "/treatments/cardiac-surgery",
  orthopedics:        "/treatments/orthopaedics",
  oncology:           "/treatments/oncology",
  "organ-transplant": "/treatments/organ-transplant",
  ivf:                "/treatments/ivf-fertility",
  // Dental & Skin
  dental:             "/treatments/dental-care",
  // Pediatric (map to same parent routes)
  "pediatric-cardiology": "/treatments/cardiac-surgery",
  "pediatric-oncology":   "/treatments/oncology",
};

export default function TreatmentsPage() {
  const [treatments, setTreatments] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/treatments`).then(r => setTreatments(r.data)).catch(console.error);
  }, []);

  // ── Filter: tab + search combined ──
  const filtered = useMemo(() => {
    let result = activeTab === "all"
      ? treatments
      : treatments.filter(t => categoryMap[t.id] === activeTab);

    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase().trim();
      result = result.filter(t =>
        t.name?.toLowerCase().includes(q) ||
        t.description?.toLowerCase().includes(q) ||
        t.id?.toLowerCase().includes(q)
      );
    }

    return result;
  }, [treatments, activeTab, searchQuery]);

  const handleSearchClear = () => setSearchQuery("");

  const handleTabChange = (val) => {
    setActiveTab(val);
    setSearchQuery("");
  };

  // ── Navigate on card click ──
  const handleCardClick = (treatmentId) => {
    const route = treatmentRouteMap[treatmentId];
    if (route) {
      navigate(route);
    }
  };

  return (
    <div data-testid="treatments-page">

      {/* ── Hero + Search Section ── */}
      <section className="bg-gradient-to-b from-orange-50 to-white py-10 md:py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* Heading */}
          <div className="text-center mb-10">
            <Badge className="bg-orange-600/10 text-orange-600 border-orange-600/20 mb-4 font-body text-xs uppercase tracking-wider">
              16+ Specialties
            </Badge>
            <h1
              className="font-heading text-4xl sm:text-5xl font-semibold text-slate-900 mb-4"
              data-testid="treatments-title"
            >
              Our Treatment <span className="text-orange-600">Specialties</span>
            </h1>
            <p className="text-base md:text-lg text-slate-500 max-w-2xl mx-auto">
              We cover all medical needs, from dental implants to heart transplants,
              with India's top hospitals and surgeons.
            </p>
          </div>

          {/* Search Bar */}
          <div className="max-w-2xl mx-auto">
            <div className="flex items-center bg-white border-2 border-orange-100 focus-within:border-orange-500 rounded-full shadow-md px-5 py-3 transition-all duration-200">
              <Search className="h-5 w-5 text-orange-400 flex-shrink-0 mr-3" />
              <input
                type="text"
                placeholder="Search treatments e.g. Knee Replacement, Dental..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                className="flex-1 bg-transparent outline-none text-slate-700 text-sm placeholder:text-slate-400"
                data-testid="treatment-search-input"
              />
              {searchQuery && (
                <button
                  onClick={handleSearchClear}
                  className="ml-2 text-slate-400 hover:text-orange-500 transition-colors"
                  data-testid="search-clear-btn"
                >
                  <X className="h-4 w-4" />
                </button>
              )}
            </div>

            {/* Live Result Count */}
            {searchQuery.trim() && (
              <p className="text-xs text-slate-400 mt-2 text-center">
                {filtered.length > 0 ? (
                  <span>
                    Showing{" "}
                    <span className="text-orange-500 font-semibold">{filtered.length}</span>
                    {" "}result{filtered.length > 1 ? "s" : ""} for "
                    <span className="text-slate-600 font-medium">{searchQuery}</span>"
                  </span>
                ) : (
                  <span>
                    No results found for "
                    <span className="text-slate-600 font-medium">{searchQuery}</span>"
                  </span>
                )}
              </p>
            )}
          </div>

        </div>
      </section>

      {/* ── Treatments Grid ── */}
      <section className="py-10 md:py-14 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Tabs value={activeTab} onValueChange={handleTabChange} className="w-full">

            {/* Tab Pills */}
            <TabsList
              className="bg-slate-100 rounded-full p-1 mb-10 flex flex-wrap justify-center gap-1"
              data-testid="treatments-tabs"
            >
              {Object.entries(categories).map(([key, label]) => (
                <TabsTrigger
                  key={key}
                  value={key}
                  className="rounded-full px-5 py-2 text-sm data-[state=active]:bg-orange-600 data-[state=active]:text-white"
                  data-testid={`tab-${key}`}
                >
                  {label}
                </TabsTrigger>
              ))}
            </TabsList>

            {/* Cards or Empty State */}
            {filtered.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {filtered.map((t) => {
                  const IconComp = ICONS[t.icon] || Heart;
                  const hasRoute = !!treatmentRouteMap[t.id];

                  return (
                    <Card
                      key={t.id}
                      onClick={() => handleCardClick(t.id)}
                      className={`group bg-white border border-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 ${
                        hasRoute ? "cursor-pointer" : "cursor-default"
                      }`}
                      data-testid={`treatment-card-${t.id}`}
                    >
                      {/* Image */}
                      <div className="relative h-48 w-full overflow-hidden">
                        <img
                          src={t.image_url}
                          alt={t.name}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
                        <div className="absolute top-3 right-3 bg-white text-orange-600 text-xs font-bold px-3 py-1 rounded-full shadow">
                          {t.price_range || `From ${t.price_from}`}
                        </div>

                        {/* "View Details" hover overlay badge */}
                        {hasRoute && (
                          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                            <span className="bg-orange-600 text-white text-xs font-semibold px-4 py-2 rounded-full shadow-lg flex items-center gap-1">
                              View Details <ArrowRight className="h-3 w-3" />
                            </span>
                          </div>
                        )}
                      </div>

                      {/* Content */}
                      <div className="p-5">
                        <h3 className="font-heading text-lg font-semibold text-slate-900 mb-2 group-hover:text-orange-600 transition-colors">
                          {searchQuery.trim()
                            ? highlightMatch(t.name, searchQuery)
                            : t.name
                          }
                        </h3>
                        <p className="text-slate-500 text-sm leading-relaxed mb-4 line-clamp-2">
                          {t.description}
                        </p>
                        <div className="flex items-center justify-between">
                          <span className="text-xs text-slate-400">Quick Consultation</span>
                          {/* Stop propagation so clicking "Get Quote" doesn't also navigate */}
                          <div onClick={e => e.stopPropagation()}>
                            <ConsultationModal
                              trigger={
                                <Button
                                  size="sm"
                                  className="bg-orange-600 hover:bg-orange-700 text-white rounded-full text-xs px-4 shadow-md hover:shadow-lg transition-all"
                                  data-testid={`get-quote-${t.id}`}
                                >
                                  Get Quote
                                </Button>
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </Card>
                  );
                })}
              </div>
            ) : (
              /* ── Empty State ── */
              <div className="flex flex-col items-center justify-center py-24 text-center">
                <div className="w-20 h-20 rounded-full bg-orange-50 flex items-center justify-center mb-6">
                  <Search className="h-9 w-9 text-orange-300" />
                </div>
                <h3 className="text-xl font-semibold text-slate-700 mb-2">No treatments found</h3>
                <p className="text-slate-400 text-sm max-w-sm mb-6">
                  We couldn't find any treatments matching "
                  <span className="text-orange-500 font-medium">{searchQuery}</span>
                  ". Try a different keyword or browse all treatments.
                </p>
                <Button
                  onClick={handleSearchClear}
                  className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-6"
                >
                  Clear Search
                </Button>
              </div>
            )}

          </Tabs>
        </div>
      </section>

      {/* ── Bottom CTA ── */}
      <section className="bg-slate-900 py-16 text-center">
        <div className="max-w-3xl mx-auto px-4">
          <h2 className="font-heading text-3xl font-semibold text-white mb-4">
            Can't Find Your Treatment?
          </h2>
          <p className="text-slate-300 mb-8">
            We can arrange treatment in any hospital across India. Contact us with
            your medical details and we'll find the best option for you.
          </p>
          <ConsultationModal
            trigger={
              <Button
                className="bg-orange-600 hover:bg-orange-700 text-white rounded-full px-8 py-6 font-semibold text-base"
                data-testid="treatments-cta-btn"
              >
                Get Free Consultation <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            }
          />
        </div>
      </section>

    </div>
  );
}

// ── Highlight Helper ──
function highlightMatch(text, query) {
  if (!query || !text) return text;
  const regex = new RegExp(
    `(${query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`,
    "gi"
  );
  const parts = text.split(regex);
  return parts.map((part, i) =>
    regex.test(part) ? (
      <mark
        key={i}
        style={{
          backgroundColor: "#FFF0EB",
          color: "#F04E30",
          borderRadius: "3px",
          padding: "0 2px",
          fontWeight: 700,
        }}
      >
        {part}
      </mark>
    ) : (
      part
    )
  );
}